import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { I18NextService } from 'angular-i18next';
import { GlobalActions } from 'core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

/**
 * Ловим ответы с кодом 401, которые прошли через AdfsReloginInterceptor
 *
 * Такие ответы по сути должны приходить с кодом 403 Forbidden,
 * однако asp.net mvc возвращает их с кодом 401 Unauthorized.
 */
@Injectable()
export class DisplayUnauthorizedErrorInterceptor implements HttpInterceptor {
    constructor(private i18: I18NextService) {}

    public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(
            catchError(err => {
                if (this.isUnauthorizedServerError(err)) {
                    try {
                        GlobalActions.displayError(this.i18.t('shared:notifications.forbiddenError'), GlobalActions.InfiniteInterval);
                    } catch (e) {
                        return throwError(e.message);
                    }
                }
                return throwError(err);
            })
        );
    }

    private isUnauthorizedServerError(error: { status: number }): boolean {
        return error instanceof HttpErrorResponse && error.status === 401;
    }
}
